import UseAxios from '../../../Api/http/http';
import { getKpiMasterDetails } from '../../../Api/request/manageKpi';


export const fetchKpiMasterDetails = async (id) => {
  try {
    const response = await UseAxios(getKpiMasterDetails(id));
    const result = response.data.kpiMasterData.map((kpi) => ({
      id: kpi.kpiId,
      name: kpi.kpiName,
    }));
    return result;
  } catch (error) {
    return [];
  }
};
